import { createContext, useContext } from 'react';

export const LanguageContext = createContext(null);
export const useLanguage = () => useContext(LanguageContext);
export const PHONE = '+40784173284';
export const ADDRESS = 'Strada Constantin Brâncoveanu 8A, 070000 Mogoșoaia, Romania';
export const MAP_QUERY = encodeURIComponent('OranjinaBiscotina, ' + ADDRESS);
export const MAP_URL = `https://www.google.com/maps/search/?api=1&query=${MAP_QUERY}`;
export const DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${MAP_QUERY}`;
export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const localDate = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
export const photo = (name) => `/images/${name}.webp`;

export const getOpenStatus = () => {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Bucharest', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
  const minutes = Number(parts.find(p => p.type === 'hour').value) * 60 + Number(parts.find(p => p.type === 'minute').value);
  return minutes >= 570 && minutes < 1290;
};